const cents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const whole = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

export default (value, withCents = false)=> {
	if (value === undefined || value === null || value === '') return '';

	const num = Number(value);

	// Check for NaN
	if (num !== num) return '';
	return withCents ? cents.format(num) : whole.format(num);
};